// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer---d7Y5q","sharedIconRoot":"sharedIconRoot---U606Y","sharedIcon":"sharedIcon---dqoEh","sharedIconLight":"sharedIconLight---KI5Bx"};